var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"google"}},[_vm._m(0),(_vm.env === 'ldev')?_c('button',{attrs:{"id":"bypass-google"},on:{"click":_vm.login}},[_vm._v(" Login ")]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"signin"}},[_c('p',[_vm._v("Authenticate using @lalamove.com")]),_c('div',{attrs:{"id":"google-login-button"}})])
}]

export { render, staticRenderFns }